enum Sections {
  PopularBodyStyles = 'popular-body-styles',
  PopularModels = 'popular-models'
}

export default Sections;
